module.exports = __webpack_public_path__ + "img/img65.65bd6481.svg";